import {GeofenceTriggerType, geofenceTriggerTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<GeofenceTriggerType>;

export const GeofenceTriggerTypeSelect = (props: Props) => {
  const {options = geofenceTriggerTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
